import  {getPolishPlurals } from '@ThemesApp/common/utils/pluralize';

export default {
  score: {
    heading: 'Bewerten Sie den Artikel',
    message: 'Abgegebene Stimme',
    votes: votes => `${getPolishPlurals(["meinung", "meinungen", "meinung"], +votes)},`,
    score: 'rate',
  },
  feedback: {
    label: 'Ist dieser Artikel hilfreich?'
  }
};
